const getImageURL = (imageName) =>
  `${process.env.REACT_APP_ASSET_URL}images/${imageName}`;

const getJsonURL = (jsonName) =>
  `${process.env.REACT_APP_ASSET_URL}jsons/${jsonName}`;

const getDocsURL = (jsonName) =>
  `${process.env.REACT_APP_ASSET_URL}docs/${jsonName}`;
const isMobileOrTablet = () => {
  const width = window.innerWidth;
  const height = window.innerHeight;
  const isMobile = width <= 768 && height <= 1024; // Adjust the values as needed
  const isTablet = width > 768 && width <= 1024 && height > 1024; // Adjust the values as needed
  return isMobile || isTablet;
};
module.exports = {
  getImageURL,
  getJsonURL,
  getDocsURL,
  isMobileOrTablet,
};
